export enum ProjectStatus {
  PENDING = "pending",
  LAUNCHED = "launched",
  SOLD_OUT = "soldOut",
}
